export default __webpack_public_path__ + "static/media/illustration-recruit-5-m.3379cada.webp";